<script setup lang="ts">
import Joi from 'joi'
import type { FormErrorEvent } from '#ui/types'

const schema = Joi.object({
  url: Joi.string().uri().required(),
})

const state = { url: "" };

const emit = defineEmits(['submitted'])

async function onSubmit () {
  emit('submitted', state.url);
}

async function onError (event: FormErrorEvent) {
  console.log(event.errors)
}

</script>

<template>
  <UForm :schema="schema" :state="state" class="space-y-4" @submit="onSubmit" @error="onError" >
    <UFormGroup label="URL" name="url" class="mb-5">
      <UInput v-model="state.url" />
    </UFormGroup>    
    <UButton type="submit" class="mt-3">
      Import
    </UButton>
  </UForm>    
</template>